import { AppConfig } from '@aipb/gulliver/env/util';
import { LanaEnv } from './lana.env';

export class LanaConfig extends AppConfig<LanaEnv> {
  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get invenioApiAvailable(): boolean {
    return !!(this.config.invenio?.downloadUrl && this.config.invenio?.uploadUrl);
  }

  get invenioDownloadUrl(): string {
    return this.config.invenio?.downloadUrl;
  }

  get invenioUploadUrl(): string {
    return this.config.invenio?.uploadUrl;
  }
}
